module.exports = __webpack_public_path__ + "img/pr-4.ec91a2be.png";